module.exports = __webpack_public_path__ + "static/media/pin_locator_blue.29567de8.svg";